<!-- checkboxInput.vue -->
<template>
    <div class="w-100" style="padding-top: 10px; padding-bottom: 10px; padding-left: 0; padding-right: 0;"> 
      <div class="">
        <div :class="['d-flex',field.class]">
          <input value="true"
                type="checkbox"
                :class="['owl360-form-check-input mt-1',  { 'is-invalid': errorMessages[field.id] }]"
                :id="field.id"
                :name="name"
                :checked="formValues[field.id]"
                :disabled="field.readonly"
                @change="updateValue($event.target.checked)"
                style="" />
          <label :for="field.id" class="form-check-label text-start" :style="styleLabel(field,'width: auto; line-height: 1.5em; margin-left: 10px;')">
            {{ field.label }}
          </label>
        </div>
        <div class="invalid-feedback" style="display: block;">
          {{ errorMessages[field.id] }}
        </div>
        <div v-if="field.msg" class="helpMessage" style="width: 100%;">
            <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    },
    formValues: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    },
    name: {type: String}
  },
  methods: {
    styleLabel(field,str) {
      return str+field.styleLabel ?? "";
    },
    updateValue(value) {
      console.log("check: "+this.field.id+"="+value)
      this.$emit('update', { [this.field.id]: value });
    }
  },
   mounted() {
    if (this.field.default !== undefined && this.formValues[this.field.id] === undefined) {
      this.$emit('update', { [this.field.id]: this.field.default });
    }
  }
  
};
</script>

<style scoped>
.caja {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
}
.form-check-label {
  padding-left: 5px;
  text-align: left; /* Alineación a la izquierda */
}
.invalid-feedback {
  color: red;
  display: block;
  font-size: 10px; /* Ajusta el tamaño del texto según necesites */
}
</style>
